import React from 'react';

interface State {
  hasError: boolean;
  requestId?: string;
}

export default class ErrorBoundary extends React.Component<
  React.PropsWithChildren<{}>,
  State
> {
  state: State = { hasError: false };

  static getDerivedStateFromError(): Partial<State> {
    return { hasError: true };
  }

  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error('Unhandled error caught by ErrorBoundary:', error, info);
    const stored = localStorage.getItem('last_failed_request_id');
    this.setState({ requestId: stored ?? undefined });
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="error-boundary">
          <h2 className="error-boundary__heading">Something went wrong.</h2>
          <p className="error-boundary__body">
            We were unable to display this page. Please try{' '}
            <button
              className="error-boundary__reload"
              onClick={() => window.location.reload()}
            >
              refreshing the page
            </button>
            , or{' '}
            <a href="/" className="error-boundary__home">
              return to the home page
            </a>
            .
          </p>
          {this.state.requestId && (
            <p className="error-boundary__reference">
              Reference: <code>{this.state.requestId}</code>
            </p>
          )}
        </div>
      );
    }

    return this.props.children;
  }
}
